module.exports = __webpack_public_path__ + "static/img/8areaB_02.eb51573.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_02.png
// module id = 1222
// module chunks = 1